import React from 'react'

export const LandingContext = React.createContext({ startLink: '/', loginLink: '', useExternalLinks: false })
